/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class UploadListController {
    public static $inject = [
        '$scope',
        '$uibModal',
        'Uploads',
        'Employee',
        'User',
        'toaster',
        'Upload',
        'bsLoadingOverlayService',
        'Orgs',
    ];

    public isHelping = false;
    public showOverlayCallOuts = false;
    public defaultValue = '';
    public docType: string = '';
    public docLabel: string = '';
    public docObj = {
            number: this.defaultValue,
            expiryDate: this.defaultValue,
            file: this.defaultValue,
            name: this.defaultValue,
            type: this.defaultValue,
            action: ''
    };
    public docOrgObj = {
            file: this.defaultValue,
            name: this.defaultValue,
            description: this.defaultValue,
            action: '',
            index: -1
    };
    public org;
    public isPassportUpload = false;
    public personalNationality = [];
    public EmployeeDocumentTypes = ['Passport', 'Visa', 'Emirates ID', 'Labour Card' , 'Other Documents'];
    public isCurrent = -1;
    public isAdmin;   
    public act;
    public isTour;
    public endTourNote;
    public hasPermission;
    public uploads;
    public employee;
    private empEventName: string;
    private empEventAddData: string;
    private depDocIndex: number;
    public canEdit = false;
    constructor(
        public $scope: angular.IScope,
        private $uibModal: any,
        private Documents: any,
        private Employee: IEmpService,
        private User: IUserService,
        private toaster: toaster.IToasterService,
        private Upload: any,
        private bsLoadingOverlayService: IBsLoadingService,
        private Orgs: IOrgsService,) {

        $scope.$emit('$pageWithHelpVisited', 8);
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.hasPermission = User.hasPermission;   
        // this.act = functions.act;     
        this.$uibModal = $uibModal;     
        this.bsLoadingOverlayService.start({ referenceId: 'loader'});
        this.Documents.list().then((response: any) => {            
            this.uploads = response;
            this.bsLoadingOverlayService.stop({ referenceId: 'loader'});
        }, 
        () => {
            this.bsLoadingOverlayService.stop({ referenceId: 'loader'});
        });
        this.loadOrg();

        this.Employee.loadEmployee(User.getCurrentUser().userData.id)
            .then((response: Restangular.IResponse) => {
                this.isTour = this.Employee.getCoTourStatus();
                let hasVisited: Boolean = false;
                this.employee = response;
                let list: Object[] = this.employee.extra.help_boxes_visited;
                for (let i: number = 0; i < list.length; i++) {
                    if (list[i] === 8) {
                        hasVisited = true;
                    }
                }

                if (!hasVisited) {
                    this.startCallouts();
                } else if (this.isTour === true) {
                    this.startCallouts();
                }
            }
        );
        this.isAdmin = User.getCurrentUser().userData.user.clearance === 'admin';
        this.canEdit = User.hasPermission("org.change_employee")
    }

    private loadOrg(): void {
        this.Orgs.getOrgFromCache((response) => {
            this.org = response;
            if (!this.org.extra.documents) {
                this.org.extra.documents = [];
            }
        });
    }

    public saveOrgDocumentEdit(model: any): void {
        /**
         * saves the modal details.
         * add the date of expiry, type and link here then pass 
         * to save function along with normal savetoApi data.
         */
        let orgDocs: any = this.org.extra.documents;
        let ldocObj: any = undefined;
        if (model.index >= 0) {
            ldocObj = orgDocs[model.index]
        } else {
            ldocObj = {

            }

            orgDocs.push(ldocObj);
        }

        if (model.name !== '') {
            ldocObj.name = model.name;
        }

        if (model.description !== '') {
            ldocObj.description = model.description;
        }

        if (model.file && model.file !== '') {
            ldocObj.file = this.docObj.file;
        }

        this.empEventName = 'org.doc.' + model.action;
        this.save_org_page();
    }

    public saveEmployeeDocumentEdit(model: any): void {
        /**
         * saves the modal details.
         * add the date of expiry, type and link here then pass
         * to save function along with normal savetoApi data.
         */
        if (!this.employee.extra.employment.documents) {
            this.employee.extra.employment.documents = [];
        }

        let empDocs: any = this.employee.extra.employment.documents;
        let ldocObj: any = undefined;

        // "Passport", "Visa", "Emirates ID", "Labour Card"
        if (model.action === 'edit' || (model.action === 'add' && model.type !== 'Other Documents')) {
            for (let i: number = 0; i < empDocs.length; i++) {
                if (empDocs[i].type === model.type) {
                    ldocObj = empDocs[i];
                    break;
                }
            }
        }

        // check if we need to add a new document
        if (!ldocObj) {
            ldocObj = {
                type: model.type
            };

            empDocs.push(ldocObj);
        }

        // update document
        if (model.number !== '') {
            ldocObj.number = model.number;
        }

        if (model.name !== '') {
            ldocObj.name = model.name;
        }

        if (model.expiryDate !== '') {
            ldocObj.expiry_date = moment(model.expiryDate).format('YYYY-MM-DD');
        }

        if (model.file && model.file !== '') {
            ldocObj.file = this.docObj.file;
        }

        this.empEventName = 'employee.profile.employment.doc.' + model.type + '.' + model.action;
        this.save_page();
    }

    public saveDocumentEdit(model: string, index: number): void {
        /**
         * saves the modal details. 
         * add the date of expiry, type and link here then pass 
         * to save function along with normal savetoApi data.
         */
        if (this.employee.extra.personal.dependants === undefined) {
            this.employee.extra.personal.depedants = {};
        }
        if(model === 'emiratesId') {
            model = 'uae_identity_card';
        } else if (model === 'medInsuranceCard') {
            model = 'med_insurance_card';
        } else if (model === 'networkList') {
            model = 'network_list';
        }
        let dependant: any = this.employee.extra.personal.dependants[this.depDocIndex];

        if (dependant[model] === undefined) { 
            dependant[model] = new Object()
        }

        if (model === 'network_list' || model === 'tob') {
            if (!dependant[model].file || this.docObj.file !== dependant[model].file) {
                dependant[model].file = this.docObj.file
            }
        } else {
            const expiryDateObj = new Date(this.docObj.expiryDate).toISOString().split('T')[0];
            dependant[model].number = this.docObj.number;
            dependant[model].name = this.docObj.name
            dependant[model].expiry_date = expiryDateObj;
            dependant[model].file = this.docObj.file
        }
        
        this.empEventName = 'employee.profile.dependants.doc.network_list.save';
        this.save_page();
    }

    public documentDeleteModal(index: number, model: string): void {
        let modalInstance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/confirmation_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.confirmation = false;
                    $scope.modalHeader = 'Delete: ' + model;
                    $scope.modalDetail = 'This document will be deleted.  Are you sure?';
                    $scope.confirmButton = 'Delete document';
                    $scope.cancelButton = 'Cancel';
                    $scope.confirm = () => {
                        $scope.confirmation = true;
                        $uibModalInstance.close($scope.confirmation);
                    };
                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };
                }
            ],
        });

        modalInstance.result.then((result) => {
            if (result) {
                const depObj = this.employee.extra.personal.dependants[index][model];
                for (let key in depObj) {
                    delete depObj[key]
                }
                this.save_page();
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
        
    }

    public documentEditModal(doc: string, index: number ): void  {
           // check what document type is being edited
        if (doc === 'visa') {
            this.docType = 'visa';
            this.docLabel = 'Visa';
        } else if (doc === 'passport') {
            this.docType = 'passport';
            this.docLabel = 'Passport';
        } else if (doc === 'uae_identity_card') {
            this.docType = 'emiratesId';
            this.docLabel = 'Emirates ID';
        } else if (doc === 'med_insurance_card') {
            this.docType = 'medInsuranceCard';
            this.docLabel = 'Medical Insurance Card';
        } else if (doc === 'tob') {
            this.docType = 'tob';
            this.docLabel = 'Table of Benefits';
        } else if (doc === 'network_list') {
            this.docType = 'networkList';
            this.docLabel = 'Network List';
        } else if (doc === 'close') {

            // closing the dialog
            return;
        } else {
            this.docType = '';
            this.docLabel = '';
        }
        this.depDocIndex = index;
        let dependant: any = this.employee.extra.personal.dependants[index]
        // assign the right object to the right model
        this.docObj.name = dependant.name;
        if ( dependant[doc] !== undefined) {
            this.docObj.number = dependant[doc].number;
            this.docObj.expiryDate = dependant[doc].expiry_date ;
            this.docObj.type = this.docType
            this.docObj.file = this.parseFileName(dependant[doc].file);
        }
        
    }
    

    public employmentDocumentEdit(index: any): void {
        if (index === 'new') {
            this.docObj = {
                name: this.defaultValue,
                type: this.defaultValue,
                number: this.defaultValue,
                expiryDate: this.defaultValue,
                file: this.defaultValue,
                action: 'add'
            };
        } else {
            let docArr: any = this.employee.extra.employment.documents;
            let docType: any;
            let docName: any;

            // account for documents that are not of a specific type
            if (docArr[index].type === 'Other Documents') {
                docType = docArr[index].type;
                docName = docArr[index].name;
            } else {
                docType = docArr[index].type;
                docName = this.defaultValue;
            }

            this.docObj = {
                name: docName,
                type: docType,
                number: docArr[index].number,
                expiryDate: docArr[index].expiry_date,
                file: docArr[index].file,
                action: 'edit'
            };

            this.isPassportUpload = true;
        }
    }

    public orgDocumentEdit(index: any): void {
        if (index === 'new') {
            this.docOrgObj = {
                name: this.defaultValue,
                description: this.defaultValue,
                file: this.defaultValue,
                action: 'add',
                index: -1
            };
        } else {
            let docArr: any = this.org.extra.documents;

            this.docOrgObj = {
                description: docArr[index].description,
                name: docArr[index].name,
                file: docArr[index].file,
                action: 'edit',
                index: index
            };

            this.isPassportUpload = true;
        }
    }

    public uploadDocModalFiles = function(params: any): void {
        const that: any = this;        
        this.bsLoadingOverlayService.start({referenceId: 'doc-loader'});
        let file: any = params.new;
        this.Upload.upload({
            url: '/api/uploads/other',
            method: 'POST',
            data: {file: file}
        }).then(
            (response) => {
                that.docObj.file = response.data.url;
                that.fileDirModel.fileName = that.parseFileName(that.docObj.file);
                this.bsLoadingOverlayService.stop({referenceId: 'doc-loader'});
            },
            () => {
                this.bsLoadingOverlayService.stop({referenceId: 'doc-loader'});
                this.toaster.pop('error', 'upload failed', '');
            }
        );
    };

    public uploadILEFiles = function(params: any): void {
        const that: any = this;        
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        let file: any = params.new;
        this.Upload.upload({
            url: '/api/uploads/other',
            method: 'POST',
            data: {file: file}
        }).then(
            (response) => {
                if (params.fileType === 'leave_process') {
                    this.leave_process.file = response.data.url;
                } else {
                    that.docObj.file = response.data.url;
                    that.fileDirModel.fileName = that.parseFileName(that.docObj.file); 
                    this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                    let newParams: any = {
                        model: params.fileType,
                        new: response.data.url,
                        old: params.old
                    };
                    this.inlineApiData = {
                        employeeId: this.employee.id,
                        fieldName: params.fileType,

                        // TODO: this needs to be cleared out and linked to the current object.
                        currentValue: params.old,
                        newValue : response.data.url,
                        employeeDataVersionId: 'still to fillout',
                        model: params.fileType
                    };

                    this.inlineEditingSave(newParams);
                }
            },
            (response) => {
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                this.toaster.pop('error', 'upload failed', '');
            }
        );
    };

    public documentModalUpload(value: any): void {
        if (value !== true) {
            this.isPassportUpload = false;
        } else {
            this.isPassportUpload = value;
        }
    }

    public uploadPassport(): void {
        const that: this = this;
        let modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/upload_passport_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', 'bsLoadingOverlayService', 'Upload',
            ($scope, $uibModalInstance, toaster, bsLoadingOverlayService, Upload) => {
                $scope.step = 0;
                $scope.state = 'auto';
                $scope.passportData = {};
                $scope.countryList = this.personalNationality;
                $scope.file = {
                    fileName: this.defaultValue,
                    fileLink: this.defaultValue,
                    fileType: this.defaultValue,
                };
                
                $scope.details = {
                    firstNames: this.defaultValue,
                    lastName: this.defaultValue,
                    passportNumber: this.defaultValue,
                    country: this.defaultValue,
                    birthDate: this.defaultValue,
                    expiryDate: this.defaultValue,
                    file: this.defaultValue
                };

                // the accura site uses country ISO codes as a return, we use normal country names.
                $scope.UploadPassport = (params) => {    
                    let scope: any = $scope;
                    this.bsLoadingOverlayService.start({referenceId: 'passport_loader'});
                    let file: any = params.new;
                    this.Upload.upload({
                        url: '/api/uploads/passport_scan',
                        method: 'POST',
                        data: {file: file}
                    }).then(
                        (response) => {
                            scope.file.fileLink = response.data.url;
                            scope.file.fileName = that.parseFileName(scope.file.fileLink);
                            this.bsLoadingOverlayService.stop({referenceId: 'passport_loader'});
                            scope.ConfirmUpload(response.data);
                        },
                        (response) => {
                            this.bsLoadingOverlayService.stop({referenceId: 'passport_loader'});
                            this.toaster.pop('error', 'Upload Failed', response.data.msg);
                            $scope.step = 1;
                            $scope.state = 'auto';
                            $scope.file = {
                                fileName: this.defaultValue,
                                fileLink: this.defaultValue,
                                fileType: this.defaultValue,
                            };
                        }
                    );
                };

                $scope.ConfirmUpload = (passportData) => {
                    $scope.passportData = this.Employee.autoPassportUpload(this.employee.id, $scope.file);
                    if (passportData.status === true) {
                        $scope.details = {
                            firstNames: passportData.data.given_names,
                            lastName: passportData.data.surname,
                            passportNumber: passportData.data.document_no,
                            country: passportData.data.country,
                            birthDate: new Date(passportData.data.date_of_birth),
                            expiryDate: new Date(passportData.data.date_of_expiry),
                            file: $scope.file
                        };

                        $scope.step = 2;
                        $scope.state = 'auto';
                    } else {
                        $scope.step = 1;
                        $scope.state = 'auto';
                    }
                };

                $scope.manualUpload = () => {
                    $scope.step = 2;
                    $scope.state = 'manual';
                };

                $scope.tryAgain = () => {
                    $scope.step = 0;
                    $scope.state = 'auto';
                };

                $scope.DeletePassport = (args) => {
                    // the logic to delete an uploaded file from the ILE edit field needs to go here 
                };

                $scope.savePassport = (params) => {

                    // add the saving here;
                    if (!this.employee.extra.employment.documents) {
                        this.employee.extra.employment.documents = [];
                    }

                    let current_passport: any = undefined;

                    // look for existing passport document
                    for (let i: number = 0; i < this.employee.extra.employment.documents.length; i++) {
                        let doc: any = this.employee.extra.employment.documents[i];
                        if (doc.type === 'Passport') {
                            current_passport = doc;
                            break;
                        }
                    }

                    if (!current_passport) {
                        current_passport = {'type': 'Passport'};
                        this.employee.extra.employment.documents.push(current_passport);
                    }

                    current_passport.file = params.file.fileLink;
                    current_passport.number = params.passportNumber;
                    current_passport.expiry_date = params.expiryDate;
                    this.save_page();
                    modal_instance.close({myData: $scope.details});                    
                };
            }],
        });

        modal_instance.result.then();
    }

    public deleteOrgDocModal(doc_index: number): void {
        const org: any = this.org;
        const that: this = this;
        const doc: any = org.extra['documents'][doc_index];
        let doc_title: string = doc.name;

        let modalInstance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/confirmation_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', 
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.confirmation = false;
                    $scope.modalHeader = 'Delete: ' + doc_title;
                    $scope.modalDetail = 'This document will be deleted.  Are you sure?';
                    $scope.confirmButton = 'Delete document';
                    $scope.cancelButton = 'Cancel';
                    $scope.confirm = () => {
                        $scope.confirmation = true;
                        $uibModalInstance.close($scope.confirmation);
                    };
                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };
                }
            ],
        });

        modalInstance.result.then((result) => {
            if (result) {
                this.emitEvent('org.doc.delete');
                org.extra['documents'].splice(doc_index, 1);
                this.save_org_page();
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }

    public delete_doc_modal(doc_index: number): void {
        const empl: any = this.employee;
        const that: this = this;
        const doc: any = empl.extra['employment']['documents'][doc_index];
        let doc_title: string = doc.type;
        if (doc.type === 'Other Documents') {
            doc_title = doc.name;
        }

        let modalInstance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/confirmation_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.confirmation = false;
                    $scope.modalHeader = 'Delete: ' + doc_title;
                    $scope.modalDetail = 'This document will be deleted.  Are you sure?';
                    $scope.confirmButton = 'Delete document';
                    $scope.cancelButton = 'Cancel';
                    $scope.confirm = () => {
                        $scope.confirmation = true;
                        $uibModalInstance.close($scope.confirmation);
                    };
                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };
                }
            ],
        });

        modalInstance.result.then((result) => {
            if (result) {
                this.emitEvent('employee.profile.employment.doc.'+doc.type+'.delete');
                empl.extra['employment']['documents'].splice(doc_index, 1);
                this.save_page();
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }


    public save_org_page(): void {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        this.org.put().then((response) => {
            // Check if we need to emit an event log
            if (this.empEventName) {
                this.emitEvent(this.empEventName, this.empEventAddData);

                // Reset event data
                this.empEventName = '';
                this.empEventAddData = '';
            }
            this.org = response;
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            this.toaster.pop('success', 'Saved');
            
        }, 
        (response: any) => {
            if (response.status === 403) {
                this.toaster.pop('error', 'Access Denied', response.data.detail);
            } else if (response.status === 400) {
                this.toaster.pop('warning', 'Validation Failed', response.data[0] || response.data);
            } else {
                this.toaster.pop('error', 'Server error', 'Please, try again later');
            }
        });
    }

    public save_page(): void {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        this.employee.put().then((response) => {
            // Check if we need to emit an event log
            if (this.empEventName) {
                this.emitEvent(this.empEventName, this.empEventAddData);

                // Reset event data
                this.empEventName = '';
                this.empEventAddData = '';
            }
            this.employee = response;
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            this.toaster.pop('success', 'Saved');

        },
        (response: any) => {
            if (response.status === 403) {
                this.toaster.pop('error', 'Access Denied', response.data.detail);
            } else if (response.status === 400) {
                this.toaster.pop('warning', 'Validation Failed', response.data[0] || response.data);
            } else {
                this.toaster.pop('error', 'Server error', 'Please, try again later');
            }
        });
    }

    public parseFileName(input: any): string {
        if (!_.isEmpty(input)) {
            return decodeURI(input.substring(input.lastIndexOf('/') + 1));   
        }
    }

    public delete(id: string): void {
        this.$scope.$emit('$EL', 'files.delete', id);
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', function ($scope: any, $uibModalInstance: any): void {
                $scope.confirmation = false;
                $scope.modalHeader = 'Delete file';
                $scope.modalDetail = 'This file will be deleted.  Are you sure?';
                $scope.confirmButton = 'Delete file';
                $scope.cancelButton = 'Cancel';
                let value: boolean = false;
                $scope.confirm = () => {
                    value = true;
                    $uibModalInstance.close(value);
                };
                $scope.cancel = () => {
                    value = false;
                    $uibModalInstance.close(value);
                };
            }],
            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });
        modalInstance.result.then((result) => {
            if (result) {
                this.Documents.delete(id).then((response: any) => {
                this.uploads = response;
                this.toaster.pop('success', 'Success', 'File Deleted');
            }, () => {
                this.toaster.pop('error', 'Error', 'Server error');
            });
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
        
    }

    public nextCallout (params: any): any {
        if (this.hasPermission(params)) {
        } else if (!this.hasPermission(params)) {
            this.isCurrent = this.isCurrent + 1;
        } else if (params === 'all') {
            this.isCurrent = this.isCurrent + 1;   
        }
    }

    public startCallouts = () => {
        if (this.isHelping) {
            if (this.isTour === true) {
                this.Employee.setCoTourStatus(false);
                this.isTour = this.Employee.getCoTourStatus();
            }
            this.isHelping = false;
            this.showOverlayCallOuts = false;
            this.isCurrent = -1;
        } else if (!this.isHelping) {
            this.isHelping = true;
            this.showOverlayCallOuts = true;
            this.isCurrent = 0;
        }
    }

    public endTour(): any {
        if (this.isTour === true) {
            this.startCallouts();
            this.showOverlayCallOuts = true;
            this.endTourNote = true;
            this.Employee.setCoTourStatus(false);

        } else {
            if (this.isTour === true) {
                this.Employee.setCoTourStatus(false);
                this.isTour = this.Employee.getCoTourStatus();
            }

            this.isHelping = false;
            this.showOverlayCallOuts = false;
            this.isCurrent = -1;
        }
        
    }

    public addEditOrgDocuments(): void {
        const that: this = this;
        let modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/org_document_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', ($scope, $uibModalInstance, toaster) => {
                $scope.C = that;
            }],
        });

        modal_instance.result.then(() => {});
    }

    // following two functions are for converting the bootstrap modals into UIB modals.
    public addEditEmploymentDocuments(): void {
        const that: this = this;
        let modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/employment_document_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', ($scope, $uibModalInstance, toaster) => {
                $scope.C = that;
            }],
        });

        modal_instance.result.then(() => {});
    }

    public addEditDependantsDocuments(): void {
        const that: this = this;
        let modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/dependants_document_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', ($scope, $uibModalInstance, toaster) => {
                $scope.C = that;
            }],
        });

        modal_instance.result.then(() => {});
    }

    public emitEvent(eventName: string, eventAddData?: string): void {
        this.$scope.$emit('$EL', eventName, eventAddData);
    }

    public checkFile(index: number, doc: string) {
        let dependant: any = this.employee.extra.personal.dependants[index][doc];
        let fileLength: number;
        if (dependant === undefined) {
            return false;
        } else if (dependant !== undefined) {
            fileLength = Object.keys(dependant).length
            if (fileLength === 0 || dependant.file === '') {
                return false;
            }
        }
        return true;
    }
}

angular.module('beneple.upload')
    .controller('UploadListController', UploadListController);





// WEBPACK FOOTER //
// ./frontend/scripts/upload/controllers/upload-list.controller.ts